export default {
  translations:{
    billetConfirmation: {
      cashTitle: "Gerar boleto à vista",
      installmentTitle: "Gerar boleto das parcelas",
      close: "Fechar aviso",
      cancel: "Cancelar",
      confirm: "Gerar boleto",
      generating: "Gerando boleto...",
      cashWarning: "Uma ou mais CDAs selecionadas já possuem boleto gerado. Caso deseje continuar, o boleto anterior será cancelado.",
      installmentWarning: "Uma ou mais parcelas selecionadas já possuem boleto gerado. Caso deseje continuar, o boleto anterior será cancelado.",
      overdueWithDate: "O boleto será emitido com vencimento em {{date}}, dia útil mais próximo, porque existem parcelas vencidas dentre as selecionadas.",
      overdue: "O boleto será emitido com vencimento conforme a regra vigente, porque existem parcelas vencidas entre as selecionadas.",
      generateError: "Não foi possível gerar o boleto. Tente novamente.",
      checkError: "Não foi possível consultar os boletos anteriores. Tente novamente.",
      missingOverdue: "A negociação {{number}} possui parcelas em atraso. A negociação poderá ser perdida se:",
      overdue90Days: "O atraso em uma parcela superar 90 dias.",
      overdueThree: "Houver atraso em 3 parcelas consecutivas.",
      overdueLast: "Houver atraso na última parcela.",
      payOverdueFirst: "É indicado quitar primeiramente as parcelas em atraso.",
      installmentDetails: "Parcela {{number}} — {{value}} — vencimento em {{date}}",
      generateInstallment: "Gerar parcela {{number}}",
      confirmSelected: "Para continuar com as parcelas selecionadas ({{numbers}}), clique em Gerar boleto.",
    },
    navbar:{
      home: "Início",
      contacts: "Contatos",
      doubts: "Dúvidas",
      services: {
        menu: "Serviços",
        debts: "Consultar Dívidas",
        installment: "Consultar Parcelamento",
        protested: "Títulos Protestados",
        signature: "Validar Assinatura",
        library: "Biblioteca Digital",
        seeAll: "Ver todos",
      },
      institutional: {
        menu: "Institucional",
        pgm: "Sobre a PGM",
        whoswho: "Quem é quem",
        transparency: "Transparência",
        regulatoryLaws: "Leis regulamentadoras",
        publicTenders: "Central de Licitações de Fortaleza",
        news: "Notícias",
        ethics: "Código de ética",
        strategicPlanning: "Planejamento estratégico",
      },
      tooltip:{
        attendant: "Ir para a área do atendente"
      },
      aria: {
        pgmLogo: "Logo da PGM",
        homeLink: "Ir para a página inicial",
        openNavigation: "Abrir menu de navegação",
        closeNavigation: "Fechar menu de navegação",
        servicesMenu: "Menu de serviços",
        institutionalMenu: "Menu institucional",
        externalLinks: "Links externos",
      },
      externalLinksTitle: "Links externos",
    },
    errorPages: {
      common: {
        errorLabel: "Erro {{code}}:",
        links: {
          home: "Início",
          installments: "Consultar Parcelamentos",
          debts: "Consultar Dívidas",
          signature: "Validar Assinatura",
          doubts: "Dúvidas",
          contacts: "Contatos",
        },
        support: {
          message: "Se preferir, entre em contato com o setor de atendimento da Dívida Ativa, através dos canais abaixo:",
          email: "atendimento.da@pgm.fortaleza.ce.gov.br",
          contact: "(85) 98419-2045"
        },
      },
      "403": {
        title: "Acesso negado",
        description: "Seu usuário não tem permissão para acessar esta página.",
        linksPrompt: "Você pode voltar usando o link abaixo:",
        back: "Início do Portal Admin",
      },
      "404": {
        title: "Página não encontrada",
        description:
          "O sistema não encontrou a página que você procurava, o<br/>endereço está inválido ou a página está indisponível.",
        linksPrompt: "Por favor, tente novamente usando um dos links abaixo:",
      },
      "500": {
        title: "Erro interno no servidor.",
        description:
          "Desculpe o transtorno. Estamos passando por uma instabilidade<br/>momentânea. Tente novamente em 10 minutos.",
      },
    },
    home: {
      slideshow: {
        aria: {
          region: "Destaques do Portal da PGM",
          previous: "Destaque anterior",
          next: "Próximo destaque",
        },
        controls: {
          previous: "Anterior",
          next: "Próximo",
        },
        welcome: {
          title: "Bem-vindo(a) ao Portal da PGM",
          description:
            "Negocie e quite suas dívidas em poucos minutos. Realize seu atendimento online com um de nossos atendentes no Balcão Virtual.\n\nClique no botão \"Baixar Guia\" para obter o passo a passo de como utilizar nossos serviços.",
          imageAlt: "Atendimento do Portal da PGM de Fortaleza",
          actions: {
            negotiate: "Negociar agora",
            guide: "Baixe o guia",
          },
        },
        virtualDesk: {
          title: "Você pode ser atendido sem sair de casa",
          description:
            "O <b>atendimento da Dívida Ativa</b>, passará a ser, preferencialmente, de forma online, via <b>Balcão Virtual</b>, a partir de 1°/12/2022.\n\nO <b>atendimento presencial</b> ocorrerá mediante o agendamento prévio. Para mais detalhes, acesse \"Saiba mais\".",
          imageAlt: "Atendente do Balcão Virtual da PGM",
          actions: {
            open: "Balcão virtual",
            details: "Saiba mais",
          },
        },
        protest: {
          title: "Suporte do Protesto",
          description:
            "O Instituto de Protesto do Ceará está disponibilizando o número de <b>atendimento exclusivo aos devedores das procuradorias: (85) 98200-9501</b>, para você que precisa regularizar a sua situação financeira.\n\nEntre em contato e saiba mais!",
          imageAlt: "Suporte de atendimento do Instituto de Protesto",
          actions: {
            support: "Contato suporte",
          },
        },
        debts: {
          title: "Consulte suas Dívidas de Fortaleza",
          description:
            "Consulte suas dívidas, gere boleto à vista ou parcelado e acompanhe o andamento de maneira rápida e prática, sem sair de casa.",
          imageAlt: "Consulta de dívidas no Portal da PGM",
          actions: {
            negotiate: "Negociar agora",
            guide: "Baixe o guia",
          },
        },
      },
      whatsapp: {
        label: "Fale conosco pelo WhatsApp",
        tooltip: "Whatsapp",
      },
      onlineServices: {
        overline: "Nossos serviços online",
        title: "Escolha como prefere realizar o seu atendimento",
        recommended: "Recomendado",
        allServices: {
          title: "Todos os serviços",
          description:
            "Você consulta seus débitos, gera boleto à vista ou parcelado e acessa demais contatos da PGM.",
          actions: {
            access: "Acessar serviços",
          },
        },
        virtualDesk: {
          title: "Balcão Virtual",
          description:
            "Converse com um de nossos atendentes em tempo real agora mesmo em uma de nossas salas online.",
          actions: {
            rooms: "Ver salas online",
          },
        },
        debtsApp: {
          title: "App Dívida Ativa",
          description:
            "Você também pode baixar o aplicativo para consultar seus débitos e gerar boleto à vista ou parcelado.",
          actions: {
            android: "Android",
            ios: "iOS",
          },
        },
      },
    },
    virtualDesk: {
      title: "Balcão virtual",
      instructions: {
        title: "Antes de iniciar seu atendimento, tenha em mãos:",
        identityDocument: "Documento de identidade (RG, CPF ou CNH)",
        proofOfAddress: "Comprovante de endereço",
      },
      browserNotice: "Use Google Chrome ou Safari para melhor compatibilidade.",
      aria: {
        close: "Fechar Balcão virtual",
      },
      attendants: {
        deskFallback: "Balcão {{number}}",
        attendantFallback: "Atendente",
        status: {
          available: "Disponível",
          busy: "Em atendimento",
        },
        actions: {
          call: "Chamar",
          busy: "Ocupado",
        },
      },
      empty: {
        description: "No momento não há atendentes disponíveis.",
        serviceHours: "Horário de atendimento",
        weekdays: "segunda - sexta",
        hours: "08:00 - 16:30",
      },
      contributorForm: {
        title: "Identificação para atendimento",
        description: "Para acessar o Balcão Virtual, por favor preencha abaixo com seu nome e o(s) CPF/CNPJ que deseja atendimento.",
        fields: {
          name: "Seu nome",
          document: "CPF/CNPJ para atendimento",
          documentPlaceholder: "000.000.000-00",
          additionalDocument: "CPF/CNPJ adicional {{number}}",
        },
        actions: {
          addDocument: "Adicionar mais",
          removeDocument: "Remover CPF/CNPJ",
          continue: "Continuar",
          loading: "Carregando",
        },
        errors: {
          notFound: "Não foram encontrados débitos para o CPF/CNPJ informado.",
          server: "Não foi possível estabelecer uma conexão com o servidor. Tente novamente mais tarde.",
        },
        aria: {
          close: "Fechar identificação para atendimento",
          removeDocument: "Remover CPF/CNPJ adicional {{number}}",
        },
      },
    },
    whoswho: {
      title: "Quem é quem",
      subtitle: "Conheça a gestão e os setores da Procuradoria Geral do Município",
      prosecutors: {
        sectionName: "Procuradores",
        seeMore: "Ver mais",
        seeLess: "Ver menos",
        imageAlt: "Foto de {{name}}",
        people: {
          helio: {
            position: "Procurador-Geral",
            bio:
              "Bacharel em Direito pela Universidade Federal do Ceará (UFC). É Pós-Graduado em Direito Processual Penal, Mestre e Doutor em Direito Constitucional. Foi Presidente da OAB/CE por dois mandatos (2004/2006 e 2007/2009) e Professor da UNI7 (Centro Universitário 7 de Setembro). No Governo do Estado, exerceu os cargos de Assessor para Assuntos Internacionais (2013 a 2014) e de Secretário de Estado da Justiça e Cidadania (2015 a 2017). Foi Procurador-Geral da Assembleia Legislativa (2019 a 2021) e pela segunda vez, consecutiva, é Conselheiro Federal da OAB – Secção Ceará (2019 a 2022 e 2022 a 2025). Ocupou a presidência da Comissão Nacional de Direitos Humanos do Conselho Nacional da OAB (2019-2022) e foi representante do órgão no Conselho Nacional de Direitos Humanos/Ministério de Direitos Humanos e Cidadania (2023-2024). Exerceu o cargo de Assessor Jurídico e de Relações Institucionais da Presidência da Assembleia Legislativa do Ceará (02/2022 12/2024).",
          },
          romulo: {
            position: "Subprocurador-Geral",
            bio:
              "Graduado em Direito pela Faculdade de Direito (1992), com especialização em direito público (2014), pela Universidade Federal do Ceará (1992), mestrado (2008) e doutorado (2013) em Direito Constitucional pela Universidade de Fortaleza, com doutorado-sanduíche e Pós-doutorado em Ciência Política pela Boston University, Massachusetts, EUA (2014). É docente nos programas de Pós-Graduação em Direito (mestrado e doutorado) e de Mestrado em Direito e Gestão de Conflitos e Direito Constitucional do Curso de Direito, na Unifor. Procurador municipal, nível 20, da Prefeitura de Fortaleza, onde já atuou como Procurador-Geral (2001 a julho de 2004). Foi Diretor Geral da Câmara Municipal de Fortaleza (2005 a 2009) e Assessor Institucional da Vice-Prefeitura de Fortaleza (2009 a 2010).",
          },
          rodrigo: {
            position: "Subprocurador-Geral",
            bio:
              "Bacharel em Direito pela Universidade de Fortaleza (Unifor). É Pós-Graduado em Direito Eleitoral pelo Instituto Brasileiro de Desenvolvimento e Pesquisa (IDP) e Direito Processual Penal pela Unifor. Foi Assessor Jurídico do Gabinete da Prefeita de Fortaleza entre 2005 e 2011 e Assessor Especial entre 2011 e 2012. Exerceu o cargo de Assessor Jurídico Parlamentar na Câmara dos Deputados em Brasília, entre 2015 e 2017. Foi Secretário-Geral da Comissão de Direito Eleitoral da OAB/CE. Advogado com atuação em diversas campanhas eleitorais em âmbito municipal e estadual. É Subprocurador-Geral da Procuradoria-Geral do Município de Fortaleza (2025).",
          },
          andreLeite: {
            position: "Subprocurador-Geral",
            bio:
              "Graduado em Direito pela Universidade de Fortaleza e pós-graduado em Direito e Processos Constitucionais. É Procurador do Município de Fortaleza desde 2020. Anteriormente, exerceu o cargo de Assessor Técnico de Conselheiro do Tribunal de Contas do Estado do Ceará, entre 2018 e 2020. Na Procuradoria-Geral do Município de Fortaleza, chefiou a Procuradoria da Administração Indireta de julho de 2022 a agosto de 2026.",
          },
          marcela: {
            position: "Subprocuradora-Geral",
            bio:
              "Procuradora do Município de Fortaleza desde 2018. Também é membro da Câmara da Prevenção e Resolução de Conflitos da Administração Pública Municipal de Fortaleza, desde a implantação. Vice-Presidente da Associação dos Procuradores da Administração Centralizada de Fortaleza (APACEFOR). Advogada atuante nas áreas de Direito Eleitoral e Direito Público Ex-Analista Judiciário do TRE-CE (2012-2018). Mestranda em Direito e Gestão de Conflitos na Universidade de Fortaleza – UNIFOR Pós-graduada em Direito Tributário pela Universidade Anhanguera-Uniderp Co-autora das obras Direito Municipal Em Debate (vol. 8 - Editora Forum) e Questões Discursivas Comentadas – Procuradoria Geral do Município (Editora JusPodivm)",
          },
          joaoPaulo: {
            position: "Subprocurador-Geral",
            bio:
              "Advogado formado pela Universidade de Fortaleza – UNIFOR. Pós graduação em Direito Processual Civil. Consultor Jurídico na área de Licitações e Contratos e Direito Empresarial. Procurador do Município de Pacajus. Possui mais de 15 anos de experiência nas searas contenciosa e consultiva. Atua há mais de 8 (oito) anos na área de licitações e contratos junto à Procuradoria Geral do Município de Fortaleza.",
          },
        },
      },
      departments: {
        sectionName: "Setores",
        explanationBefore: "As atribuições de cada setor estão detalhadas na",
        law: "Lei Complementar n° 315",
        explanationAfter: ".",
        columns: {
          acronym: "Sigla",
          fullName: "Nome Completo",
          extension: "Ramal",
          personInCharge: "Responsável",
          email: "E-mail",
        },
        rows: {
            prodesp: "Procuradoria de Desenvolvimento e Pesquisa",
            profaz: "Procuradoria da Fazenda Pública",
            propad: "Procuradoria de Processo Administrativo Disciplinar",
            prourma: "Procuradoria de Urbanismo e Meio Ambiente",
            conger: "Consultoria Geral",
            projud: "Procuradoria Judicial",
            ctigi: "Coordenadoria de Tecnologia, Governança e Inovação",
            procadin: "Procuradoria da Administração Indireta",
            prolic: "Procuradoria de Licitações, Contratos Administrativos e Controle Externo",
            coafi: "Coordenadoria Administrativo-Financeira",
            probsb: "Procuradoria de Representação em Brasília",
        },
      },
    },
    regulatoryLaws: {
      title: "Leis regulamentadoras",
      subtitle: "Conheça a base jurídica da PGM.",
      laws: {
        lc6: "Lei Complementar nº 6, de 29 de maio de 1992",
        lc9: "Lei Complementar nº 9, de 29 de julho de 1994",
        lc10: "Lei Complementar nº 10, de 29 de setembro de 1995",
        lc16: "Lei Complementar nº 16, de 24 de maio de 2004",
        lc71: "Lei Complementar nº 71, de 23 de novembro de 2009",
        lc122: "Lei Complementar nº 122, de 30 de novembro de 2012",
        lc151: "Lei Complementar nº 151, de 04 de julho de 2013",
        lc185: "Lei Complementar nº 185, de 19 de dezembro de 2014",
        lc252: "Lei Complementar nº 252, de 03 de julho de 2018",
        lc253: "Lei Complementar nº 253, de 03 de julho de 2018",
        lc274: "Lei Complementar nº 274, de 20 de dezembro de 2019",
        lc315: "Lei Complementar nº 315, de 23 de dezembro de 2021",
      },
    },
    services: {
      title: "Serviços da PGM",
      subtitle: "Escolha como podemos te ajudar.",
      items: {
        digitalLibrary: {
          title: "Biblioteca digital",
          description:
            "Acervo de livros jurídicos da Thomson Reuters ProView, disponível para consulta pelos procuradores e servidores da PGM.",
        },
        signature: {
          title: "Consulta de assinaturas",
          description:
            "Documentos assinados digitalmente pelos procuradores da PGM, a partir de 2021, podem ter sua autenticidade validada aqui.",
        },
        debts: {
          title: "Consulta de dívidas",
          description:
            "Débitos com a Prefeitura que não foram pagos no prazo são inscritos na Dívida Ativa. Aqui você verifica se há pendências no seu nome, gera boleto à vista ou simula um parcelamento.",
        },
        installments: {
          title: "Consulta de parcelamentos",
          description:
            "Se você já negociou uma dívida com a PGM, aqui pode acompanhar as parcelas pagas e gerar boletos das parcelas a vencer ou vencidas.",
        },
        protested: {
          title: "Consulta de títulos protestados",
          description:
            "Dívidas com a Prefeitura podem ser enviadas para protesto em cartório, o que gera restrições no seu nome. Aqui você consulta se há protestos vinculados ao seu CPF ou CNPJ.",
        },
      },
    },
    protestedTitles: {
      title: "Títulos Protestados",
      notice: "Este serviço é de uso exclusivo dos cartórios.",
      submit: "Pesquisar",
      fields: {
        cda: "Número da CDA",
        password: "Senha do cartório",
        protocols: "Números de protocolo",
        email: "E-mail",
        togglePassword: "Mostrar ou ocultar senha",
      },
      bulk: {
        toggle: "Gerar múltiplos boletos",
        submit: "Gerar boletos",
        success:
          "{{total}} protocolos foram processados com sucesso!\nUm e-mail de resumo será enviado em até 2 horas.",
      },
      actions: {
        billet: "Gerar boleto",
        dam: "Gerar DAM",
        cda: "Gerar CDA",
      },
      errors: {
        required: "Preencha este campo.",
        invalidCredentials: "Número da CDA ou senha inválidas.",
        unavailable:
          "Não foi possível estabelecer uma conexão com o servidor.\nPor favor, tente novamente mais tarde.",
      },
      result: {
        cda: "Número da CDA:",
        installment: "Nº do parcelamento: {{code}}",
        balance: "Saldo devedor: {{value}}",
        requestedAt: "Solicitado em {{date}}",
        tribute: "Tributo:",
        administrativeInscription: "Inscrição administrativa:",
        inscribedAt: "Inscrita em:",
        fiscalYear: "Exercício:",
        originalValue: "Valor Original:",
        phase: "Fase:",
      },
    },
    transparency: {
      title: "Transparência",
      subtitle:
        "Consulte os valores dos honorários advocatícios e auxílios recebidos pelos procuradores municipais, conforme as diretrizes de publicidade e transparência ativa da Procuradoria-Geral do Município de Fortaleza e em observância à tese de repercussão geral fixada pelo Supremo Tribunal Federal (julgamento conjunto da RCL 88.319-ED-MC-REF, ADI 6.606-MC-REF, ADI 6.601, ADI 6.604, RE 968.646 e RE 1.059.466)",
      fields: {
        name: "Nome do procurador",
        month: "Mês",
        year: "Ano",
      },
      minChars: "Mínimo de 3 caracteres",
      loading: "Carregando...",
      loadError: "Não foi possível carregar os dados da transparência. Tente novamente mais tarde.",
      search: "Consultar procuradores",
      emptyState:
        "Informe um nome acima para consultar os procuradores. Os nomes são apresentados na forma cadastrada no Sistema. Assim, para encontrar uma pessoa de nome \"Silva\", digite \"silva\" ou \"silv\".",
      results: {
        count: "Procuradores encontrados ( {{count}} )",
        view: "Visualizar",
        back: "Voltar",
      },
      notFound:
        "Nenhum procurador encontrado com o nome \"{{term}}\" no mês e ano selecionados.",
      warnings: {
        noFees:
          "Não houve repasse de honorários advocatícios (verba sucumbencial) para este procurador no mês e ano selecionados.",
        noAids:
          "Não houve lançamento de Auxílio Saúde e Auxílio Alimentação para este procurador no mês e ano selecionados.",
        none:
          "Não houve repasse de honorários ou auxílios para este procurador no mês e ano selecionados.",
      },
      fees: {
        title: "Honorários",
        gross: "Valor Bruto",
        otherDeductions: "Outras deduções",
        tax: "I.R. Retido na Fonte",
        net: "Valor Líquido",
        legal:
          "Distribuição de verba honorária sucumbencial apurada no mês de competência, em conformidade com o disposto no art. 85, § 19, do Código de Processo Civil (Lei nº 13.105/2015), c/c a Lei Municipal nº 9.876/2012 e a regulamentação dada pelo Decreto Municipal nº 14.500/2020, observadas as diretrizes de transparência e o teto constitucional firmados pelo Supremo Tribunal Federal na ADI 6053.",
      },
      aids: {
        title: "Auxílios",
        meal: "Alimentação",
        health: "Saúde",
        legal:
          "Concessão de indenizações de caráter estritamente indenizatório referentes ao Auxílio-Saúde e Auxílio-Alimentação, pagas com esteio na Lei Orgânica do Município de Fortaleza, na Portaria Conjunta PGM/SEPOG nº 08/2024 e no Edital de Credenciamento nº 03/2025, não integrando a base de cálculo para fins de retenção do Imposto de Renda Retido na Fonte (IRRF).",
      },
      legal: {
        title: "Fundamento Legal",
      },
      portal: {
        text: "Para consultar outras parcelas, acesse o",
        link: "Portal da Transparência do Município",
      },
    },
    login: {
      title: "Área do Atendente",
      subtitle: "Entre com a sua conta de atendente",
      email: "E-mail",
      password: "Senha",
      required: "Preencha este campo",
      invalid: "Usuário ou senha incorretos",
      forbidden: "Seu usuário não tem acesso à Área do Atendente",
      unavailable: "Não foi possível entrar agora. Tente novamente mais tarde.",
      help: "Esqueceu a senha ou tem dúvidas?",
      contact: "Fale conosco",
      submit: "Entrar",
      showPassword: "Mostrar senha",
      hidePassword: "Ocultar senha",
    },
    admin: {
      title: "Portal Admin",
      login: {
        title: "Portal Admin",
        subtitle: "Entre com a sua conta de administrador do portal",
        forbidden: "Seu usuário não tem acesso ao Portal Admin",
        unavailable: "Não foi possível entrar agora. Tente novamente mais tarde.",
      },
      home: {
        welcome: "Olá, {{name}}",
        subtitle: "Bem-vindo ao Portal Admin.",
        logout: "Sair",
        loading: "Carregando...",
      },
      account: {
        open: "Conta de {{name}}",
        changePassword: "Alterar senha",
        logout: "Sair",
        password: {
          title: "Alterar senha",
          intro: "Ao alterar, as outras sessões abertas com a sua conta serão encerradas.",
          currentPassword: "Senha atual",
          password: "Nova senha",
          passwordConfirmation: "Confirmar nova senha",
          passwordHint: "Mínimo de {{min}} caracteres.",
          showPassword: "Mostrar senhas",
          hidePassword: "Ocultar senhas",
          cancel: "Cancelar",
          save: "Alterar senha",
          saving: "Alterando...",
          changed: "Senha alterada.",
          errors: {
            invalid: "Valor inválido.",
            generic: "Não foi possível alterar a senha. Tente novamente.",
            currentPassword: {
              blank: "Informe a senha atual.",
              invalid: "Senha atual incorreta.",
            },
            password: {
              blank: "Informe a nova senha.",
              too_short: "A senha deve ter pelo menos {{min}} caracteres.",
              same: "A nova senha deve ser diferente da atual.",
            },
            passwordConfirmation: {
              confirmation: "As senhas não conferem.",
            },
          },
        },
      },
      nav: {
        label: "Menu do Portal Admin",
        open: "Abrir menu",
        close: "Fechar menu",
        sections: {
          virtualCounter: "Balcão virtual",
          pages: "Páginas",
          access: "Acesso",
        },
        items: {
          ticketWindows: "Salas de atendimento",
          attendants: "Gerenciar atendentes",
          transparency: "Transparência",
          notices: "Avisos",
          users: "Usuários",
        },
      },
      placeholder: "Você está na tela {{screen}}.",
      transparency: {
        listLabel: "Planilhas",
        periodTitle: "{{month}} de {{year}}",
        months: [
          "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
          "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
        ],
        attorneysCount: "Procuradores: {{count}}",
        status: {
          draft: "Em rascunho",
          published: "Publicada",
        },
        actions: {
          create: "Nova planilha",
          downloadTemplate: "Baixar modelo .csv",
          publish: "Publicar",
          unpublish: "Despublicar",
          back: "Voltar para a lista de planilhas",
        },
        empty: "Nenhuma planilha cadastrada.",
        loadError: "Não foi possível carregar as planilhas. Tente novamente mais tarde.",
        detailError: "Não foi possível carregar a planilha. Tente novamente mais tarde.",
        selectPrompt: "Selecione uma planilha ao lado para ver os dados, ou clique em “Nova planilha” para cadastrar uma nova.",
        tabs: {
          label: "Dados da planilha",
          attorneys: "Procuradores ({{count}})",
          legalBasis: "Fundamentos legais",
        },
        noAttorneys: "Nenhum procurador nesta planilha.",
        fees: {
          title: "Honorários",
          gross: "Valor bruto",
          otherDeductions: "Outras deduções",
          incomeTax: "I.R. retido na fonte",
          net: "Valor líquido",
        },
        aids: {
          title: "Auxílios",
          health: "Saúde",
          meal: "Alimentação",
        },
        notes: {
          fees: "Honorários",
          aids: "Auxílios",
          empty: "Não informado",
          placeholder: "Você pode editar esse campo depois...",
          save: "Salvar fundamentos",
          saveError: "Não foi possível salvar os fundamentos legais. Tente novamente.",
        },
        newPeriod: {
          title: "Nova planilha de transparência",
          close: "Fechar",
          month: "Mês",
          year: "Ano",
          file: "Arquivo da planilha",
          dropzone: "Clique aqui ou arraste um arquivo para cá",
          change: "Trocar",
          hint: "Somente arquivos do tipo .csv, .xlsx ou .ods de até 30MB",
          cancel: "Cancelar",
          submit: "Criar planilha",
          validating: "Validando dados da planilha. Por favor, aguarde...",
          creating: "Criando planilha. Por favor, aguarde...",
          confirmTitle: "Confirmar planilha de transparência",
          ignoredWarning: "Linhas sem prontuário ou com prontuário duplicado serão ignoradas.",
          summary: "Procuradores que serão cadastrados: {{count}}. Linhas ignoradas: {{ignored}}.",
          confirm: "Concordar e continuar com a criação",
          reasons: {
            missing_registration: "Sem prontuário",
            duplicated: "Prontuário duplicado",
          },
          errors: {
            generic: "Não foi possível processar a planilha. Tente novamente.",
            file_required: "Selecione o arquivo da planilha.",
            invalid_format: "Formato inválido. Envie um arquivo .csv, .xlsx ou .ods.",
            file_too_large: "O arquivo excede o tamanho máximo de 30MB.",
            unreadable_file: "Não foi possível ler o arquivo. Verifique se ele não está corrompido.",
            header_not_found: "Cabeçalho não encontrado. A planilha precisa das colunas “Prontuário” e “Nome do Servidor”.",
            missing_column: "Coluna obrigatória ausente: “{{column}}”.",
            ambiguous_column: "Mais de uma coluna corresponde a “{{column}}”.",
            invalid_value: "Valor inválido na linha {{line}}, coluna “{{column}}”.",
            no_rows: "Nenhum procurador válido encontrado na planilha.",
            invalid_period: "Mês ou ano inválido.",
            unregistered_attorney: "Procurador não cadastrado: {{name}} (prontuário {{registration}}, linha {{line}}). Solicite o cadastro antes de importar a planilha.",
          },
        },
        publication: {
          cancel: "Cancelar",
          error: "Não foi possível concluir a ação. Tente novamente.",
          publish: {
            title: "Confirmar publicação",
            description: "Esta planilha será publicada e seus dados poderão ser consultados no Portal do Contribuinte.",
            question: "Você poderá despublicá-la a qualquer momento. Deseja continuar?",
            confirm: "Publicar planilha",
          },
          replace: {
            title: "Substituir planilha publicada",
            description: "Já existe uma planilha publicada para {{period}}. Ao continuar, ela será despublicada automaticamente e voltará a ficar em rascunho.",
            question: "Deseja publicar esta planilha no lugar dela?",
            confirm: "Publicar e substituir",
          },
          unpublish: {
            title: "Confirmar despublicação",
            description: "Esta planilha voltará a ficar em rascunho e seus dados deixarão de aparecer no Portal do Contribuinte.",
            question: "Você poderá publicá-la novamente a qualquer momento. Deseja continuar?",
            confirm: "Despublicar planilha",
          },
        },
      },
      attendants: {
        title: "Gerenciar atendentes",
        subtitle: "Cadastre e gerencie os acessos da equipe do balcão virtual.",
        caption: "Atendentes cadastrados",
        loadError: "Não foi possível carregar os atendentes.",
        emptySearch: "Nenhum atendente encontrado para “{{term}}”.",
        empty: {
          active: "Nenhum atendente ativo.",
          inactive: "Nenhum atendente desativado.",
          all: "Nenhum atendente cadastrado.",
        },
        count: "{{count}} atendente",
        count_plural: "{{count}} atendentes",
        actions: {
          create: "Novo atendente",
        },
        notices: {
          created: "Atendente {{name}} criado.",
          deactivated: "Atendente {{name}} desativado.",
          reactivated: "Atendente {{name}} reativado.",
        },
        form: {
          createTitle: "Novo atendente",
          editTitle: "Editar atendente",
          errors: {
            roleIds: {
              invalid: "Selecione um perfil disponível para a equipe do balcão virtual.",
            },
          },
        },
      },
      users: {
        title: "Usuários",
        subtitle: "Cadastre, edite e desative quem acessa o sistema.",
        caption: "Usuários cadastrados",
        search: "Buscar por nome ou e-mail",
        clearSearch: "Limpar busca",
        noName: "Sem nome",
        you: "Você",
        loadError: "Não foi possível carregar os usuários.",
        retry: "Tentar novamente",
        emptySearch: "Nenhum usuário encontrado para “{{term}}”.",
        empty: {
          active: "Nenhum usuário ativo.",
          inactive: "Nenhum usuário desativado.",
          all: "Nenhum usuário cadastrado.",
        },
        columns: {
          name: "Nome",
          email: "E-mail",
          roles: "Perfis",
          status: "Status",
          actions: "Ações",
        },
        status: {
          label: "Status",
          active: "Ativo",
          inactive: "Inativo",
          filter: {
            active: "Ativos",
            inactive: "Inativos",
            all: "Todos",
          },
        },
        role: {
          label: "Perfil",
          all: "Todos os perfis",
        },
        count: "{{count}} usuário",
        count_plural: "{{count}} usuários",
        actions: {
          create: "Novo usuário",
          edit: "Editar",
          editUser: "Editar {{name}}",
          deactivate: "Desativar",
          deactivateUser: "Desativar {{name}}",
          reactivate: "Reativar",
          reactivateUser: "Reativar {{name}}",
          ownDeactivate: "Você não pode desativar o próprio usuário",
        },
        notices: {
          created: "Usuário {{name}} criado.",
          updated: "Alterações de {{name}} salvas.",
          deactivated: "Usuário {{name}} desativado.",
          reactivated: "Usuário {{name}} reativado.",
        },
        form: {
          createTitle: "Novo usuário",
          editTitle: "Editar usuário",
          name: "Nome",
          email: "E-mail",
          ownEmail: "Você não pode alterar o próprio e-mail.",
          roles: "Perfis de acesso",
          activityDescriptions: {
            admin_all: "Acesso total à área do atendente.",
            attendant_all: "Realiza atendimentos no balcão virtual.",
            portal_admin_all: "Acesso total ao Portal Admin, incluindo esta tela.",
            portal_admin_transparency: "Edita os dados da Transparência no Portal Admin.",
            portal_admin_who_is_who: "Edita o Quem é quem no Portal Admin.",
            portal_admin_contacts: "Edita os contatos no Portal Admin.",
            portal_admin_carousel: "Edita o carrossel da página inicial no Portal Admin.",
            portal_admin_ticket_windows: "Gerencia as salas de atendimento no Portal Admin.",
            portal_admin_attendants: "Gerencia os atendentes no Portal Admin.",
            portal_admin_notices: "Cria e publica os avisos da página inicial no Portal Admin.",
          },
          ownAccess: "Você não pode remover o seu próprio acesso ao Portal Admin.",
          password: "Senha",
          newPassword: "Nova senha",
          passwordConfirmation: "Confirmar senha",
          passwordHint: "Mínimo de {{min}} caracteres.",
          showPassword: "Mostrar senha",
          hidePassword: "Ocultar senha",
          resetPassword: "Redefinir senha",
          keepPassword: "Manter a senha atual",
          resetPasswordHint: "Ao salvar, as sessões abertas deste usuário serão encerradas.",
          resetOwnPasswordHint: "A sua sessão atual continua ativa.",
          cancel: "Cancelar",
          save: "Salvar",
          saving: "Salvando...",
          errors: {
            invalid: "Valor inválido.",
            generic: "Não foi possível salvar. Tente novamente.",
            name: {
              blank: "Informe o nome.",
            },
            email: {
              blank: "Informe o e-mail.",
              invalid: "Informe um e-mail válido.",
              taken: "Já existe um usuário com este e-mail.",
              own_email: "Você não pode alterar o próprio e-mail.",
            },
            password: {
              blank: "Informe a senha.",
              too_short: "A senha deve ter pelo menos {{min}} caracteres.",
              too_long: "A senha é longa demais.",
            },
            passwordConfirmation: {
              confirmation: "As senhas não conferem.",
            },
            roleIds: {
              blank: "Selecione ao menos um perfil.",
              own_access: "Você não pode remover o seu próprio acesso ao Portal Admin.",
            },
          },
        },
        confirm: {
          cancel: "Cancelar",
          error: "Não foi possível concluir. Tente novamente.",
          deactivate: {
            title: "Desativar {{name}}?",
            description: "O usuário perde o acesso imediatamente e as sessões abertas são encerradas. Você pode reativá-lo depois.",
            confirm: "Desativar",
          },
          reactivate: {
            title: "Reativar {{name}}?",
            description: "O usuário volta a entrar no sistema com a senha que já tinha e os mesmos perfis.",
            confirm: "Reativar",
          },
        },
      },
      notices: {
        title: "Avisos",
        subtitle: "Crie, agende e publique os avisos exibidos na página inicial do portal.",
        caption: "Avisos cadastrados",
        loadError: "Não foi possível carregar os avisos.",
        retry: "Tentar novamente",
        until: "até {{date}}",
        periodRange: "{{start}} até {{end}}",
        empty: {
          all: "Nenhum aviso cadastrado.",
          draft: "Nenhum aviso em rascunho.",
          scheduled: "Nenhum aviso agendado.",
          live: "Nenhum aviso no ar agora.",
          ended: "Nenhum aviso encerrado.",
        },
        columns: {
          title: "Título",
          period: "Período",
          status: "Status",
          actions: "Ações",
        },
        status: {
          draft: "Rascunho",
          scheduled: "Agendado",
          live: "No ar",
          ended: "Encerrado",
        },
        filter: {
          label: "Status",
          all: "Todos",
          draft: "Rascunho",
          scheduled: "Agendados",
          live: "No ar",
          ended: "Encerrados",
        },
        actions: {
          create: "Novo aviso",
          preview: "Pré-visualizar",
          previewNotice: "Pré-visualizar {{title}}",
          edit: "Editar",
          editNotice: "Editar {{title}}",
          publish: "Publicar",
          publishNotice: "Publicar {{title}}",
          unpublish: "Despublicar",
          unpublishNotice: "Despublicar {{title}}",
          duplicate: "Duplicar",
          duplicateNotice: "Duplicar {{title}}",
          remove: "Excluir",
          removeNotice: "Excluir {{title}}",
          removePublished: "Despublique o aviso para poder excluí-lo",
        },
        notices: {
          created: "Aviso “{{title}}” criado como rascunho.",
          updated: "Alterações de “{{title}}” salvas.",
          duplicated: "Cópia de “{{title}}” criada como rascunho.",
          publish: "Aviso “{{title}}” publicado.",
          unpublish: "Aviso “{{title}}” despublicado.",
          remove: "Aviso “{{title}}” excluído.",
          error: "Não foi possível concluir. Tente novamente.",
        },
        form: {
          createTitle: "Novo aviso",
          editTitle: "Editar aviso",
          publishedHint: "Este aviso está publicado. As alterações valem para quem abrir o portal a partir de agora.",
          title: "Título",
          body: "Mensagem",
          period: "Período de exibição",
          startsAt: "Início",
          endsAt: "Fim",
          buttons: "Botões",
          confirmationLabel: "Texto do botão de fechar",
          actionLabel: "Texto do botão de ação",
          actionUrl: "Link do botão de ação",
          actionUrlHint: "Opcional. Começa com https://. Abre em uma nova aba.",
          optional: "Opcional.",
          preview: "Pré-visualizar",
          previewEmptyTitle: "Sem título",
          cancel: "Cancelar",
          save: "Salvar",
          saving: "Salvando...",
          bodyHint: "Aceita negrito, itálico, links e listas. Veja em Opções de formatação.",
          formatting: {
            toggle: "Opções de formatação",
            options: {
              bold: { label: "Negrito" },
              italic: { label: "Itálico" },
              link: { label: "Link" },
              list: { label: "Lista" },
              paragraph: {
                label: "Parágrafo",
                description: "Deixe uma linha em branco entre um parágrafo e outro.",
              },
            },
            previewNote: "Use Pré-visualizar para conferir como o aviso vai aparecer no portal antes de publicar.",
          },
          errors: {
            invalid: "Valor inválido.",
            generic: "Não foi possível salvar. Tente novamente.",
            title: {
              blank: "Informe o título.",
              too_long: "O título é longo demais.",
            },
            body: {
              blank: "Escreva a mensagem.",
              too_long: "A mensagem é longa demais.",
              link: "Os links da mensagem precisam começar com http:// ou https://.",
            },
            confirmationLabel: {
              blank: "Informe o texto do botão.",
              too_long: "O texto do botão é longo demais.",
            },
            actionLabel: {
              blank: "Informe o texto do botão de ação.",
              too_long: "O texto do botão é longo demais.",
            },
            actionUrl: {
              blank: "Informe o link do botão de ação.",
              invalid: "Informe um link começando com http:// ou https://.",
            },
            startsAt: {
              blank: "Informe a data e a hora de início.",
            },
            endsAt: {
              blank: "Informe a data e a hora de fim.",
              before_start: "O fim precisa ser depois do início.",
              past: "Este período já terminou. Escolha um fim no futuro para manter o aviso publicado.",
            },
            base: {
              overlap: "Já existe um aviso publicado nesse período: “{{title}}” ({{start}} até {{end}}). Ajuste as datas ou despublique o outro aviso.",
            },
          },
        },
        confirm: {
          cancel: "Cancelar",
          error: "Não foi possível concluir. Tente novamente.",
          ended: "Este aviso já terminou. Edite o período antes de publicar.",
          publish: {
            title: "Publicar “{{title}}”?",
            description: "O aviso aparece na página inicial do portal durante o período configurado.",
            confirm: "Publicar",
          },
          unpublish: {
            title: "Despublicar “{{title}}”?",
            description: "O aviso deixa de aparecer para quem abrir o portal a partir de agora e volta a ser rascunho.",
            confirm: "Despublicar",
          },
          remove: {
            title: "Excluir “{{title}}”?",
            description: "O rascunho é excluído e não pode ser recuperado.",
            confirm: "Excluir",
          },
        },
      },
    },
    validateSignature: {
      title: "Validar Assinatura",
      subtitle:
        "Informe o código de verificação do documento para validar um documento assinado digitalmente no sistema Ágilis.",
      submit: "Validar assinatura",
      field: {
        label: "Código de verificação",
        required: "Preencha este campo.",
      },
      messages: {
        idle:
          "Informe o código de verificação acima para validar a sua assinatura digital.",
        notFound:
          "Nenhum documento encontrado com o código informado.\nVerifique se os dados estão corretos e tente novamente.",
        serverError:
          "Não foi possível estabelecer uma conexão com o servidor.\nPor favor, tente novamente mais tarde.",
      },
      document: {
        name: "Documento:",
        code: "Código de verificação:",
        date: "Data da verificação:",
        download: "Baixar documento",
      },
      signatures: {
        title: "Assinaturas no documento",
      },
      signedAt: "Assinado em {{date}}",
      signatureDateUnavailable: "Data de assinatura não informada",
    },
    faq: {
      title: "Dúvidas frequentes",
      subtitle: "Busque por categoria para encontrar a resposta da sua pergunta.",
    },
    news: {
      title: "Notícias",
      subtitle:
        "Acompanhe as últimas novidades e ações da Procuradoria Geral do Município.",
      latest: "Notícias Mais Recentes",
    },
    contacts: {
      title: "Contatos",
      subtitle:
        "Converse conosco. Temos atendimentos especializados para atender você da melhor forma. Verifique abaixo os setores e respectivos contatos:",
      card: {
        email: "E-mail:",
        whatsapp: "Whatsapp:",
        whatsappTag: "Whatsapp",
        phone: "Telefone:",
      },
    },
    aboutPgm: {
      title: "Sobre a PGM",
      subtitle:
        "Conheça a história, a estrutura e os princípios da Procuradoria Geral do Município de Fortaleza",
      imageAlt: "Equipe da Procuradoria Geral do Município de Fortaleza",
      intro1:
        "A Procuradoria Geral do Município (PGM) é o órgão gestor do Sistema Jurídico Municipal, responsável pela defesa judicial e extrajudicial do Município de Fortaleza, pela consultoria jurídica dos órgãos municipais, bem como pela inscrição e cobrança da dívida ativa municipal.",
      intro2:
        "É responsável, em toda a sua plenitude, pela defesa de seus interesses em juízo e fora dele, bem como pelas funções de consultoria jurídica, ressalvadas as competências autárquicas, sob a égide dos princípios da legalidade e da indisponibilidade dos interesses públicos.",
      anchors: {
        title: "Nesta página",
        about: "Sobre a PGM",
        identity: "Identidade institucional",
        timeline: "Linha do tempo",
        competitions: "Histórico de concursos",
        laws: "Leis complementares",
      },
      identity: {
        label: "Identidade institucional",
        title:
          "Conheça a missão, a visão, o negócio e os valores que orientam a atuação da PGM",
        valuesLabel: "Valores",
        pillars: {
          mission: {
            title: "Missão",
            description:
              "Promover a defesa do interesse público municipal na prestação de soluções em serviços jurídicos aos órgãos e demais entidades na recuperação dos créditos inscritos na dívida ativa, arrecadação e recuperação em decorrência das transações, meio ambiente e urbanismo, consultoria, pesquisa, contencioso e tecnologia da informação com comprometimento, efetividade, cooperação, proatividade, foco em prazos, ética e transparência, visando a segurança jurídica e a sustentabilidade organizacional.",
          },
          vision: {
            title: "Visão",
            description:
              "Consolidar-se, até 2028, como referência nacional na entrega de soluções em serviços jurídicos aos órgãos e demais entidades com foco na máxima efetividade da política pública de recuperação e arrecadação dos créditos tributários e não tributários, meio ambiente e urbanismo, consultoria, contencioso, pesquisa e tecnologia da informação com excelência na sustentabilidade organizacional.",
          },
          business: {
            title: "Negócio",
            description:
              "Soluções em serviços jurídicos aos órgãos e demais entidades na defesa do interesse público municipal (recuperação dos créditos inscritos na dívida ativa, arrecadação e recuperação em decorrência das transações, meio ambiente e urbanismo, consultoria, pesquisa, contencioso e tecnologia da informação).",
          },
        },
        values: {
          commitment: {
            title: "Comprometimento",
            description:
              "Compromisso dos Colaboradores no desempenho das suas atribuições e na busca de soluções para os problemas organizacionais, bem como o compromisso com o interesse público.",
          },
          cooperation: {
            title: "Cooperação",
            description:
              "Postura participativa e colaborativa junto aos seus colegas, gestores e equipe de trabalho, bem como com outras unidades e parceiros agregando valor para alcançar os objetivos organizacionais.",
          },
          effectiveness: {
            title: "Efetividade",
            description:
              "Busca da melhoria continuada no exercício da sua missão institucional sendo eficiente (fazendo o que deve ser feito) e eficaz (fazendo da melhor maneira o que deve ser feito).",
          },
          ethics: {
            title: "Ética e Transparência",
            description:
              "Acreditamos no trabalho e nas relações com ética, transparência e responsabilidade individual e coletiva em conformidade com a legalidade.",
          },
          deadlines: {
            title: "Foco em prazos",
            description:
              "Capacidade para atingir os prazos requeridos nos processos organizacionais e no desempenho de suas atribuições, otimizando-se custos e perdas por decorrência de prazos.",
          },
          proactivity: {
            title: "Proatividade",
            description:
              "Senso de iniciativa e prontidão, atitude e determinação frente aos problemas e soluções organizacionais.",
          },
          legalCertainty: {
            title: "Segurança jurídica",
            description:
              "Assegurar a legalidade nas decisões e ações com previsibilidade e coerência, garantindo aos agentes públicos e aos cidadãos maior segurança em suas relações, mantidos os interesses públicos municipais.",
          },
          sustainability: {
            title: "Sustentabilidade",
            description:
              "Empenho na busca da sustentabilidade do órgão, envolvendo práticas de gestão que promovam a transformação digital, a responsabilidade fiscal e socioambiental, e a longevidade organizacional.",
          },
        },
        actions: {
          whoswho: "Quem é quem",
          news: "Ver notícias",
        },
      },
      timeline: {
        label: "Linha do tempo",
        title:
          "Criação e gestão de Procuradores-gerais do Município de Fortaleza",
        creation: {
          title: "Lei de criação",
          description:
            "Lei nº 5154, de 25 de maio de 1979\nEmenta: Cria a Procuradoria-Geral do Município e dá outras providências.\nPrefeito de Fortaleza – Lúcio Alcântara",
        },
      },
      competitions: {
        label: "Histórico de concursos de Fortaleza",
        title: "Concursos para o cargo de Procurador-geral do Município",
        columns: {
          act: "Ato",
          signature: "Assinatura",
          publication: "Publicação no Diário Oficial do Município",
        },
      },
      laws: {
        label:
          "Institucionalização da PGM de Fortaleza após a Constituição Federal de 1988",
        title:
          "Leis complementares que organizam a Procuradoria-Geral do Município",
        amendmentsLabel: "alterações, modificações ou revogações",
      },
    },
    consultDebts: {
      view: {
        title: "Consultar Dívidas",
        description: "Informe apenas um CPF ou CNPJ. Para uma busca específica, preencha também uma das demais informações.",
        validation: {
          invalidDocument: "CPF/CNPJ é inválido",
          requiredDocument: "CPF/CNPJ é obrigatório",
          requiredType: "Tipo é obrigatório",
          requiredField: "Preenchimento obrigatório",
        },
        errors: {
          title: "Nenhum débito encontrado.",
          description: "Verifique se os dados estão corretos e faça uma nova consulta.",
        },
        aria: {
          expandForm: "Expandir formulário de consulta",
          collapseForm: "Minimizar formulário de consulta",
          clearField: "Limpar campo {{field}}",
        },
        tooltips: {
          maximizeForm: "Maximizar",
          minimizeForm: "Minimizar",
        },
        fields: {
          document: "CPF/CNPJ",
          administrativeInscription: "Inscrição Administrativa",
          cda: "Certidão de Dívida Ativa (CDA)",
          judicialProcess: "Processo Judicial",
          onlyOneOptional: "Insira somente uma informação além do CPF/CNPJ",
        },
        sefin: {
          description: "Para débitos tributários ainda não inscritos em Dívida Ativa, consulte o site da",
          link: "SEFIN.",
        },
        actions: {
          search: "Consultar dívida",
        },
        initialMessage: {
          document: "Informe um CPF ou CNPJ acima para consultar as dívidas.",
          optionalField: "Para uma busca específica, preencha uma das demais informações.",
        },
        loading: "Consultando dívidas...",
        otherDebts: {
          message: "Existem outros débitos para esse CPF/CNPJ",
          action: "Ver tudo",
        },
        summary: {
          openInscriptions: "CDAs em aberto:",
          balance: "Saldo devedor:",
        },
      },
      inscriptionItem: {
        phases: {
          protested: "Protestado",
          legalAction: "Ajuizado",
        },
        aria: {
          openAdministrative: "Abrir inscrição administrativa {{number}}",
          closeAdministrative: "Fechar inscrição administrativa {{number}}",
          selectAll: "Selecionar todas as CDAs da inscrição administrativa {{number}}",
          payPix: "Pagar CDA {{cda}} via Pix",
          generateBillet: "Gerar boleto da CDA {{cda}}",
          selectCda: "Selecionar CDA {{cda}}",
        },
        labels: {
          administrativeInscription: "Inscrição administrativa:",
          cdaCount: "(CDAs: {{count}})",
          address: "Endereço",
          subtotal: "Subtotal:",
          cda: "CDA:",
          exercise: "Exercício:",
          phase: "Fase:",
          registry: "Cartório:",
          process: "Processo:",
          cdaTotal: "Total da CDA:",
          refisCdaTotal: "Total da CDA REFIS:",
          phone: "Fone:",
        },
        actions: {
          payPix: "Pagar via Pix",
          generateBillet: "Gerar boleto",
          viewAddress: "Ver endereço",
        },
        lockedCredit: "Crédito não habilitado para negociação",
        registryModal: {
          title: "Endereço do Cartório",
        },
      },
      receiptTypeItem: {
        count: {
          inscription: "inscrição",
          inscriptions: "inscrições",
          inscriptionCapitalized: "Inscrição",
          inscriptionsCapitalized: "Inscrições",
        },
        errors: {
          connection: "Não foi possível estabelecer uma conexão com o servidor. Tente novamente mais tarde.",
          generatePayment: "Não foi possível gerar o pagamento no momento, por favor, tente novamente mais tarde.",
          selectInstallment: "Selecione uma opção para efetuar o parcelamento.",
          extinctConnection: "Não foi possível consultar as inscrições extintas. Tente novamente mais tarde.",
        },
        labels: {
          cda: "CDA:",
          refis: "REFIS",
          totalTribute: "Valor total do tributo:",
          totalTributeWith: "Valor total do tributo com",
          subtotal: "Subtotal:",
          subtotalWith: "Subtotal com",
          selectedTotal: "Total Selecionado:",
          selectedTotalWith: "Total Selecionado com",
        },
        actions: {
          no: "Não",
          yes: "Sim",
          continueQuestion: "Deseja continuar?",
          close: "Fechar",
          consultInstallment: "Consultar parcelamento",
          generateCashBillet: "Gerar boleto à vista",
          generatingCashBillet: "Gerando boleto à vista...",
          makeInstallment: "Efetuar parcelamento",
          giveUp: "Desistir",
          confirmInstallment: "Ok. Efetuar parcelamento!",
          payPix: "Pagar via Pix",
          generatingPayment: "Gerando pagamento...",
          generateBillet: "Gerar boleto",
          generatingBillet: "Gerando boleto...",
          loadingOptions: "Carregando opções...",
          simulateInstallment: "Simular parcelamento",
        },
        paymentModal: {
          title: "Pagamento à vista",
          close: "Fechar pagamento",
          downloadBillet: "Baixar boleto",
          amount: "Valor a pagar",
          dueDate: "Data de vencimento",
          notice: "Se o pagamento não for confirmado, sua solicitação será cancelada automaticamente.",
          howToPay: "Como pagar:",
          steps: [
            "Abra o aplicativo do seu banco e vá para a área de pagamento.",
            "Selecione a opção \"Ler QR code\" ou \"Pix Copia e Cola\".",
            "Escaneie o código QR ou copie e cole o código que está ao lado.",
            "Confira todas as informações do boleto e autorize o pagamento.",
            "Você receberá uma confirmação do pagamento através dos nossos canais.",
          ],
          scanQrCode: "Escaneie este código com o seu telefone para abrir o pagamento no aplicativo do seu banco",
          qrCodeLabel: "QR Code para pagamento via Pix",
          manualPixCode: "ou insira o código Pix manualmente",
          loadingPix: "Carregando código Pix...",
          copyPixCode: "Copiar código Pix",
          copied: "Código Pix copiado",
        },
        restriction: {
          title: "Alerta de restrição",
          description: "Algumas das inscrições selecionadas possuem restrições na quantidade de parcelas. Veja abaixo as inscrições com restrição:",
          consequence: "Isso afetará a quantidade de vezes que seu parcelamento poderá ser realizado.",
        },
        cancellation: {
          title: "Confirmação de cancelamento",
          description: "O cancelamento do seu parcelamento atual implica modificação das regras atuais e a adesão aos benefícios do novo Programa. Deseja continuar?",
        },
        installment: {
          title: "Parcelamento",
          success: "Seu parcelamento foi efetuado com sucesso.",
          instructions: "Utilize o número do parcelamento abaixo para consultar e emitir o boleto.",
          number: "Número do Parcelamento:",
        },
        simulation: {
          title: "Simulação de Parcelamento",
          refisDescription: "Parcelamento simulado no Refis-TMRSU com os descontos previstos na Lei Nº 11.521/2025.",
          refisRules: "Conforme o art. 5º, os descontos do REFIS somente incidem sobre juros e multas de natureza moratória, da atualização monetária e das multas de caráter punitivo, quando houver.",
          selectOption: "Clique em uma das opções abaixo para selecionar a quantidade de parcelas:",
          loadingInstallments: "Carregando parcelas...",
          unselectOption: "Clique para desmarcar",
          chooseOption: "Clique para selecionar",
          discount: "{{percent}}% de desconto",
          minimumInstallmentWarning: "O parcelamento em questão não alcançou o \"Valor Mínimo da Parcela\" estabelecido no decreto Nº 17.015, Art. 7°, § 2º. Por isso ele só poderá ser pago à vista. Para pagar à vista clique no botão \"Gerar boleto à vista\".",
          readTerms: "Leia o ato e concorde para prosseguir com a negociação.",
          legalAct: "ATO n° 001/2023",
          legalActDate: "Fortaleza/CE, 09 de janeiro de 2023",
          themeLabel: "Tema:",
          theme: "prescrição no parcelamento",
          terms: "Declaro estar ciente de que o pedido de parcelamento do crédito tributário, presencial ou online, interrompe a prescrição (o prazo de cobrança volta a correr do zero) e implica no reconhecimento da existência da dívida mediante confissão extrajudicial, ainda que posteriormente indeferido ou não paga a primeira parcela (Código Tributário Nacional, art. 174, parágrafo único, inciso IV - STJ, Súmula 653).",
          agree: "CONCORDO",
          disclaimer: "Informamos que os valores acima apresentados são apenas uma simulação. Ao efetuar o parcelamento, os valores das parcelas serão reajustados mensalmente conforme a legislação vigente (SELIC).",
          emailLabel: "Digite seu e-mail.",
          emailPlaceholder: "seuemail@email.com",
        },
        confirmation: {
          title: "Informações importantes!",
          refisTitle: "Somente para REFIS - Taxa do Lixo (LEI Nº 11.521):",
          items: {
            activation: "1. Para ativar o parcelamento é preciso efetuar o pagamento da primeira parcela.",
            activationDeadline: "2. Se a ativação não for feita até o vencimento, o parcelamento será cancelado.",
            unpaidInstallments: "3. Se o parcelamento estiver ativo e acumular três parcelas não pagas, o parcelamento será perdido.",
            dueDate: "4. As parcelas, da segunda em diante, ficarão com o vencimento para o último dia útil de cada mês.",
            reduction: "5. A cada parcelamento perdido, o próximo parcelamento efetuado sofrerá uma redução de até 6 parcelas.",
            refisCancellation: "6. O parcelamento será cancelado automaticamente nas seguintes hipóteses:",
            refisConsecutive: "I - inadimplemento de 3 (três) parcelas consecutivas ou alternadas;",
            refisPeriod: "II - inadimplência de qualquer parcela por período superior a 3 (três) meses.",
            refisBalance: "7. O cancelamento do parcelamento implicará a exigibilidade imediata do saldo devedor remanescente e sua inscrição ou reinscrição na Dívida Ativa do Município, perdendo-se os descontos a que se refere o art. 8º desta Lei sobre o saldo remanescente.",
          },
        },
        empty: {
          toRegister: "Existem créditos a inscrever. Por favor, procure o atendimento presencial.",
          extinct: "Não foram encontradas inscrições extintas para os dados informados.",
        },
        loading: {
          extinctInscriptions: "Carregando inscrições extintas...",
        },
        aria: {
          openExtinctGroup: "Abrir agrupamento de inscrições extintas",
          closeExtinctGroup: "Fechar agrupamento de inscrições extintas",
          openGroup: "Abrir agrupamento",
          closeGroup: "Fechar agrupamento",
          selectAllGroup: "Selecionar todas as CDAs deste agrupamento",
        },
        groups: {
          cdaCount: "(CDAs: {{count}})",
          openNegotiation: "Negociação em aberto com {{count}} {{inscriptions}}",
          openInscriptions: "{{count}} {{inscriptions}} em aberto",
          extinct: "Extintos",
          negotiation: "Negociação {{number}}",
          penalty: "Multa autônoma",
          restricted: "Em aberto com restrição",
          legalAction: "Em aberto com ajuizamento",
          administrative: "Em aberto na fase administrativa",
          negotiationUnavailable: "não habilitado para negociação",
          negotiationDate: "Data da negociação: {{date}}",
        },
      },
    },
    consultInstallments: {
      view: {
        title: "Consultar Parcelamentos",
        description: "Você pode informar apenas um CPF ou CNPJ. Para uma busca específica, preencha o N° do parcelamento.",
        validation: {
          invalidDocument: "CPF/CNPJ é inválido",
          requiredDocument: "CPF/CNPJ é obrigatório",
        },
        errors: {
          title: "Nenhum parcelamento encontrado.",
          description: "Verifique se os dados estão corretos e faça uma nova consulta.",
        },
        aria: {
          expandForm: "Expandir formulário de consulta",
          collapseForm: "Minimizar formulário de consulta",
        },
        tooltips: {
          maximizeForm: "Maximizar",
          minimizeForm: "Minimizar",
        },
        fields: {
          document: "CPF/CNPJ",
          installmentNumber: "Nº do Parcelamento",
        },
        actions: {
          search: "Consultar parcelamento",
        },
        initialMessage: {
          document: "Informe um CPF ou CNPJ acima para consultar os parcelamentos.",
          installmentNumber: "Para uma busca específica, preencha também o número do parcelamento.",
        },
        loading: "Carregando parcelamentos...",
        summary: {
          activeInstallments: "Parcelamentos ativos:",
        },
        warnings: {
          canceled: "Parcelamento cancelado. Solicite um novo parcelamento para quitar este débito.",
          lost: "Parcelamento perdido. Solicite um novo parcelamento para quitar este débito.",
        },
      },
      paymentRequestItem: {
        aria: {
          collapse: "Recolher parcelamento",
          expand: "Expandir parcelamento",
          viewAdministrativeInscription: "Consultar inscrição administrativa",
          selectAll: "Selecionar todas as parcelas do parcelamento {{number}}",
        },
        tooltips: {
          minimize: "Minimizar",
          maximize: "Maximizar",
          viewAdministrativeInscription: "Consultar inscrição administrativa",
          paidValue: "Valor pago",
          payableValue: "Valor a pagar",
          unpaidValue: "Valor não pago",
        },
        labels: {
          paymentRequest: "Parcelamento {{number}}",
          requestedAt: "Solicitado em {{date}}",
          selectedValue: "Valor selecionado:",
          administrativeInscription: "Inscrição Administrativa:",
          inscriptionDate: "Data de inscrição:",
          balance: "Saldo devedor:",
        },
        actions: {
          payPix: "Pagar via Pix",
          generatingPayment: "Gerando pagamento...",
          generateBillet: "Gerar boleto",
          generatingBillet: "Gerando boleto...",
        },
        modals: {
          inscriptions: "Inscrições",
          installmentsPayment: "Pagamento da(s) parcela(s)",
        },
      },
      installmentItem: {
        aria: {
          payPix: "Pagar parcela {{number}} via Pix",
          generateBillet: "Gerar boleto da parcela {{number}}",
          select: "Selecionar parcela {{number}}",
        },
        tooltips: {
          payPix: "Pagar via Pix",
          generateBillet: "Gerar boleto",
        },
        labels: {
          dueDate: "Vencimento: {{date}}",
          generatedBillet: "boleto gerado em {{date}}",
        },
        status: {
          paid: "pago",
          open: "em aberto",
          overdue: "atrasado",
          lost: "perdido",
          canceled: "cancelado",
        },
      },
    },
    acessibility:{
      officialDiary: "Diário Oficial",
      informationAccess: "Acesso à Informação",
      transparency: "Transparência",
      services: "Serviços",
      legislation: "Legislação"
    },
    footer: {
      credit: "Desenvolvido pela Coordenadoria de Tecnologia, Governança e Inovação da Procuradoria Geral do Município de Fortaleza.",
      address: "Endereço",
      addressLink: "Rua Israel Bezerra, 570, Dionísio Torres.\nCEP 60135-460\nFortaleza-CE. Brasil.",
      officeHours: {
        title: "HORÁRIO DE FUNCIONAMENTO",
        institutional: "Institucional",
        institutionalHours: "Segunda a Sexta, das 8h às 17h",
        debts: "Dívida Ativa",
        debtsHours: "Segunda a Sexta, das 8h às 16:30h (Presencial agendado, balcão virtual e telefones)",
        protocol: "Protocolo",
        protocolHours: "Segunda a Sexta, das 8h às 17h (Presencial)",
      },
      contact: {
        title: "CONTATO",
        debts: "Atendimento da Dívida Ativa\n(Procuradoria da Fazenda)",
        link: "Ligação e WhatsApp: (85) 98419-2045",
        callOnly: "Somente ligação: (85) 98419-2042",
        help: "Precisa de ajuda? Acesse nosso Balcão Virtual e fale com um de nossos atendentes",
        virtualDesk:"Abrir balcão virtual"
      },
    },
  },
}
